import {ROLE_VARIANTS} from '../data/roleFamilies.js';
import {getLocalizedSurgeonVariant,getRoleFamilyUiCopy} from '../data/roleFamilyTranslations.js';
import {sourceRevision} from './translationAssurance.js';
export function buildRoleVariantTranslationRows(locale) {
  const rows=ROLE_VARIANTS.flatMap(variant=>{
    const english=getLocalizedSurgeonVariant(variant,'en');
    const current=getLocalizedSurgeonVariant(variant,locale);
    return ['title','plainEnglishTitle','summary','differenceFromParent'].flatMap(field=>{
      if(!english[field])return [];
      const path='items.'+variant.variantKey+'.'+field;
      const id='roleFamilyVariants:'+path;
      return [{id,namespace:'roleFamilyVariants',path,contentArea:'know_your_team',sourceText:english[field],
        sourceRevision:sourceRevision(id,english[field]),originalText:current[field]||'',
        publicationTarget:'locale',runtimeFallbackSource:true,provenance:'role-family runtime resolver'}];
    });
  });
  const current=getRoleFamilyUiCopy(locale);
  for(const [field,sourceText] of Object.entries(getRoleFamilyUiCopy('en'))) {
    if(typeof sourceText!=='string')continue;
    const path='ui.'+field,id='roleFamilyVariants:'+path;
    rows.push({id,namespace:'roleFamilyVariants',path,contentArea:'know_your_team',sourceText,
      sourceRevision:sourceRevision(id,sourceText),originalText:current[field],publicationTarget:'locale',
      runtimeFallbackSource:true,provenance:'role-family UI runtime resolver'});
  }
  return rows;
}
